import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import Skeleton from 'react-loading-skeleton';

const ProfileAudience = ({selectedAudienceData}) => {
    const formatNumber = (number) => {
        return new Intl.NumberFormat().format(number);
    }

    return (
        <Card className="team-box profile-card">
            <CardBody className="p-4 d-flex justify-content-center align-items-center">  
                <Col xs={12} md={12} className="d-flex flex-column justify-content-center align-items-center ">
                    <img src={avatar2} alt="" className="avatar-lg img-fluid img-thumbnail rounded-circle" />
                    <p className="fs-15 mb-0 mt-1 text-muted">
                        {selectedAudienceData ? selectedAudienceData.name : <Skeleton/>}
                    </p>
                    <p className="fs-17 mb-0 mt-1">
                        Audience Sizes: <b style={{color: "#2A5B82", fontSize: "17px" }}>{selectedAudienceData ? formatNumber(selectedAudienceData.audienceSize) : <Skeleton/>}</b>
                    </p>
                </Col>
            </CardBody>
        </Card>
    );
}

export default ProfileAudience;
